import { Component, inject, effect, input } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { signal } from "@angular/core";
import { SHARED } from "../../shared";

@Component({
  selector: "app-shared-svg",
  standalone: true,
  imports: [SHARED],
  templateUrl: "./svg.component.html",
})
export class SvgComponent {
  private _http = inject(HttpClient);
  private _sanitizer = inject(DomSanitizer);

  src = input.required<string>();
  class = input<string>("");

  svgContent = signal<SafeHtml | null>(null);

  private _sanitizeClasses(className: string): string {
    if (!className) return "";

    return className
      .split(/\s+/)
      .map((c) => c.replace(/[^a-zA-Z0-9-_]/g, ""))
      .filter((c) => c) // Remove empty strings
      .join(" ");
  }

  constructor() {
    effect(() => {
      const url = this.src();
      if (!url) {
        this.svgContent.set(null);
        return;
      }

      this._http.get(url, { responseType: "text" }).subscribe({
        next: (raw) => {
          const sanitizedClass = this._sanitizeClasses(this.class());
          const withClass = raw.replace(/<svg/, `<svg class="${sanitizedClass}"`);
          const safe = this._sanitizer.bypassSecurityTrustHtml(withClass);
          this.svgContent.set(safe);
        },
        error: () => {
          this.svgContent.set(null);
        },
      });
    });
  }
}
